// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"style--checkbox--27eJh","handler":"style--handler--3YMqd","darker":"style--darker--Uq9Sw"};